import type { FC, PropsWithChildren } from "react";
import { useSidebarContext } from "../../context/SidebarContext";
import classNames from "classnames";
import {
  layoutPage,
  layoutContent,
  layoutContainer,
  layoutContentFull,
} from "@design-system";

export interface PageContentProps {
  isFooter?: boolean;
  /** Keep operational tools inside the viewport; their panes own scrolling. */
  fillViewport?: boolean;
}

export const PageContent: FC<PropsWithChildren<PageContentProps>> = function ({
  children,
  isFooter = true,
  fillViewport = false,
}) {
  const { isOpenOnSmallScreens: isSidebarOpen } = useSidebarContext();
  const url = new URL(window.location.href);
  const pathname = url.pathname;
  const searchParams = url.searchParams;
  const isFullWidthPage = ["/map", "/planner", "/daily-planner"].includes(
    pathname,
  );

  const mainClass =
    pathname === "/map" ||
    (pathname === "/planner" && searchParams.get("tab") === "route")
      ? "overflow-hidden"
      : "h-full";

  return (
    <main
      className={classNames(
        `w-full ${layoutPage} h-full`,
        mainClass,
        fillViewport && "flex min-h-0 flex-col overflow-hidden",
        isSidebarOpen
          ? "lg:ml-16 lg:w-[calc(100%-theme(space.16))]"
          : "lg:ml-64 lg:w-[calc(100%-theme(space.64))]",
      )}
    >
      <div
        className={classNames(
          isFullWidthPage
            ? fillViewport
              ? undefined
              : layoutContentFull
            : `${layoutContent} ${layoutPage}`,
          fillViewport && "flex min-h-0 flex-1 flex-col",
        )}
      >
        <div
          className={classNames(
            isFullWidthPage ? "w-full" : layoutContainer,
            fillViewport && "flex min-h-0 flex-1 flex-col",
          )}
        >
          {children}
        </div>
      </div>
      {isFooter && !fillViewport && (
        <div className="mt-4">{/* <Footer /> */}</div>
      )}
    </main>
  );
};
